// extracted by mini-css-extract-plugin
module.exports = {"root":"_2io7-","bg":"_2fgfD","arrow":"_1-PKt"};